import { PlannedActivityStatusEnum } from 'api/tillit.api-client'

export const hasCompleteStatus = (plannedActivityStatusId: PlannedActivityStatusEnum): boolean => {
  return !(plannedActivityStatusId === "NotCompleted" || plannedActivityStatusId === "Delayed" || plannedActivityStatusId === "Started")
}
